import PropTypes from "prop-types"
import { Fragment, useEffect, useState } from "react"
import { createPortal } from "react-dom"
import styled, { css } from "styled-components"
import noneThumbnail from "./../../assets/extensions-thumbnail/none.png"
import leftTableThumbnail from "./../../assets/extensions-thumbnail/left-table.png"
import rightTableThumbnail from "./../../assets/extensions-thumbnail/right-table.png"
import display12Thumbnail from "./../../assets/extensions-thumbnail/12-display.png"
import display6Thumbnail from "./../../assets/extensions-thumbnail/6-display.png"

const images = [
  { src: noneThumbnail, name: "none" },
  { src: leftTableThumbnail, name: "left-table" },
  { src: rightTableThumbnail, name: "right-table" },
  { src: display12Thumbnail, name: "12-display" },
  { src: display6Thumbnail, name: "6-display" },
]

const ImgList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
`

const ImgContainer = styled.figure`
  width: 100%;
  max-width: 180px;
  height: 100%;
  cursor: pointer;
  img {
    width: 100%;
    border-radius: 6px;
    box-sizing: border-box;
    ${(p) =>
      p.isSelected
        ? css`
            border: 1px solid #000000;
          `
        : null}
  }
`

const Heading = styled.h3`
  font-family: "Open Sans Condensed";
  font-style: normal;
  font-weight: bold;
  font-size: 21px;
  line-height: 29px;
  color: #000000;
  margin-bottom: 25px;
`

const ExtensionItem = ({ onClick, name, path, isSelected }) => {
  return (
    <ImgContainer
      key={name}
      role="button"
      isSelected={isSelected}
      onClick={() => onClick({ extension: name })}
    >
      <img src={path} alt={name} />
    </ImgContainer>
  )
}

const Extensions = ({ onClick, selected }) => {
  const [portalElement, setEl] = useState(null, selected)
  useEffect(() => {
    setEl(document.getElementById("extensions"))
  }, [])

  if (portalElement === null) return null

  return createPortal(
    <Fragment>
      <Heading>Add extensions</Heading>
      <ImgList>
        {images.map((img) => {
          return (
            <ExtensionItem
              isSelected={selected.includes(img.name)}
              key={img.name}
              name={img.name}
              onClick={onClick}
              path={img.src}
            />
          )
        })}
      </ImgList>
    </Fragment>,
    portalElement
  )
}

Extensions.propTypes = {
  onClick: PropTypes.func,
  selected: PropTypes.arrayOf(PropTypes.string),
}

export default Extensions
